import IconButton from '@material-ui/core/IconButton';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import React, {useState} from 'react';
import {useScheduleContext} from '../Utils/ScheduleContextProvider';

type Props = {
    employeeId : number;
    projectId : number;
    locked : boolean;
};

const ProjectLock : React.FC<Props> = ({employeeId, projectId, locked} : Props) => {
    const {updateLock} = useScheduleContext();
    const [submitting, setSubmitting] = useState(false);

    const handleUpdate = async () => {
        if (submitting) {
            return;
        }

        setSubmitting(true);
        await updateLock(employeeId, projectId, !locked);
        setSubmitting(false);
    };

    return (
        <IconButton size="small" edge="start" onClick={handleUpdate} disabled={submitting}>
            {locked ? <LockIcon fontSize="inherit"/> : <LockOpenIcon fontSize="inherit"/>}
        </IconButton>
    );
};

export default ProjectLock;
